'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var partnershipTileComponent = exports.partnershipTileComponent = {
    template: require('./partnership-tile.html'),
    bindings: {
        partnership: '<'
    },
    controllerAs: 'vm'
};


//////////////////
// WEBPACK FOOTER
// ./features/seller/components/partnership-tile.js
// module id = 1013
// module chunks = 0